export default __webpack_public_path__ + "static/media/yuryu-02.fc49d323.svg";